
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 25.2855C10 26.429 11.2966 27.0902 12.2221 26.4187L24.9789 17.1635C25.748 16.6056 25.7497 15.4599 24.9823 14.8996L12.2255 5.58611C11.3004 4.91073 10 5.57145 10 6.71683V25.2855Z","fill":"#10001F"}})])
          )
        }
      }
    